module.exports = __webpack_public_path__ + "static/media/urbangoo09.8b979e0d.webp";